import { clsx } from 'clsx'

/**
 * Brand gradient — blue/indigo per Master Architecture Decision 10
 * (adapted from Radiant's fuchsia/rose original):
 * linear-gradient(115deg, #e0ecff 28%, #6366f1 70%, #4338ca 100%)
 */
export function Gradient({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      {...props}
      className={clsx(
        className,
        'bg-linear-115 from-[#e0ecff] from-28% via-[#6366f1] via-70% to-[#4338ca] sm:bg-linear-145',
      )}
    />
  )
}

export function GradientBackground() {
  return (
    <div className="relative mx-auto max-w-7xl">
      <div
        className={clsx(
          'absolute -top-44 -right-60 h-60 w-[36rem] transform-gpu md:right-0',
          'bg-linear-115 from-[#e0ecff] from-28% via-[#6366f1] via-70% to-[#4338ca]',
          'rotate-[-10deg] rounded-full blur-3xl',
        )}
      />
    </div>
  )
}
